import React from 'react';
import {
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Comic } from '../../types';
import ComicCard from './ComicCard';

interface SortableComicCardProps {
  comic: Comic;
  onComicUpdate: () => void;
  onEditClick: (comic: Comic) => void;
  readOnly?: boolean;
  isDragDisabled?: boolean;
}

const SortableComicCard: React.FC<SortableComicCardProps> = ({
  comic,
  onComicUpdate,
  onEditClick,
  readOnly = false,
  isDragDisabled = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: comic.id.toString(),
    disabled: isDragDisabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`${isDragging ? 'cursor-grabbing' : 'cursor-grab'} ${
        isDragDisabled ? 'pointer-events-none' : ''
      }`}
    >
      <ComicCard
        comic={comic}
        onComicUpdate={onComicUpdate}
        onEditClick={onEditClick}
        readOnly={readOnly}
      />
    </div>
  );
};

export default SortableComicCard;